<template>
  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitFinancialData"> 
      <div class="card-body">
        <div class="form-group row">
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.financial_facilities.s_no') }}</label><span class="text-danger"> *</span>
                <base-input
                  :invalid="$v.formData.s_no.$error"
                  v-model="formData.s_no"
                  ref='s_no'
                  type="text"
                  name="name"
                  tab-index="1"
                />
                <div v-if="$v.formData.s_no.$error">
                  <span v-if="!$v.formData.s_no.required" class="text-danger">
                    {{ $tc('validation.required') }}
                  </span>
                </div>
            </div>
            <div class="col-md-6 mb-4">
                <label class="input-label">{{ $tc('profile.financial_facilities.facility_nature') }}</label><span class="text-danger"> * </span>
                <base-select
                v-model="formData.facility_nature"
                :options="facilityNatureOptions"
                :class="{'error': $v.formData.facility_nature.$error }"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                :placeholder="$t('profile.financial_facilities.facility_nature')"
                
                />
                <div v-if="$v.formData.facility_nature.$error">
                <span v-if="!$v.formData.facility_nature.required" class="text-danger">{{ $tc('validation.required') }}</span>
                </div>
            </div>
             <div class="col-md-6 mb-4">
                <label class="input-label">{{ $tc('profile.financial_facilities.type') }}</label><span class="text-danger"> * </span>
                <base-select
                v-model="formData.facility_type"
                :options="facilityTypeOptions"
                :class="{'error': $v.formData.facility_type.$error }"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                :placeholder="$t('profile.financial_facilities.type')"
                
                />
                <div v-if="$v.formData.facility_type.$error">
                <span v-if="!$v.formData.facility_type.required" class="text-danger">{{ $tc('validation.required') }}</span>
                </div>
            </div>

            <div class="col-md-6 mb-4">
                <label class="input-label">{{ $tc('profile.financial_facilities.existing_enhancement') }}</label><span class="text-danger"> * </span>
                <base-select
                v-model="formData.facility_origin"
                :options="facilityOriginOptions"
                :class="{'error': $v.formData.facility_origin.$error }"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                
                />
                <div v-if="$v.formData.facility_origin.$error">
                <span v-if="!$v.formData.facility_origin.required" class="text-danger">{{ $tc('validation.required') }}</span>
                </div>
            </div>
              <div class="col-md-12">
                 <label class="form-label">{{ $t('profile.financial_facilities.bank_name') }}</label><span class="text-danger"> *</span>
                <base-input
                  :invalid="$v.formData.bank_name.$error"
                  v-model="formData.bank_name"
                  type="text"
                  name="name"
                  tab-index="1"
                />
                <div v-if="$v.formData.bank_name.$error">
                  <span v-if="!$v.formData.bank_name.required" class="text-danger">
                    {{ $tc('validation.required') }}
                  </span>
                </div>
            </div>

            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.financial_facilities.collaterals') }}</label><span class="text-danger"> * </span>
                <base-input
                    v-model="formData.collaterals"
                    type="text"
                />
                <div v-if="$v.formData.collaterals.$error">
                <span v-if="!$v.formData.collaterals.required" class="text-danger">{{ $tc('validation.required') }}</span>
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.financial_facilities.tenor') }}</label><span class="text-danger"> * </span>
                <base-input
                  v-model="formData.tenor"
                  type="text"
                />
                <div v-if="$v.formData.tenor.$error">
                <span v-if="!$v.formData.tenor.required" class="text-danger">{{ $tc('validation.required') }}</span>
                </div>
            </div>
             <div class="col-md-6">
                <label class="form-label">{{ $t('profile.financial_facilities.amount') }}</label><span class="text-danger"> * </span>
                <div class="base-input">
                    <money
                        :class="{'invalid' : $v.formData.amount.$error}"
                        v-model="amount"
                        v-bind="defaultCurrencyForInput"
                        class="input-field"
                    />
                </div>
                <div v-if="$v.formData.amount.$error">
                    <span v-if="!$v.formData.amount.required" class="text-danger">{{ $tc('validation.required') }}</span>
                    <span v-if="!$v.formData.amount.numeric" class="text-danger">{{ $tc('validation.numbers_only') }}</span>
                    <span v-if="!$v.formData.amount.maxLength" class="text-danger">{{ $t('validation.price_maxlength') }}</span>
                    <span v-if="!$v.formData.amount.minValue" class="text-danger">{{ $t('validation.price_minvalue') }}</span>
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.financial_facilities.amount_overDue') }}</label>
                <div class="base-input">
                    <money
                        :class="{'invalid' : $v.formData.amount.$error}"
                        v-model="amount_overDue"
                        v-bind="defaultCurrencyForInput"
                        class="input-field"
                    />
                </div>
                <div v-if="$v.formData.amount_overDue.$error">
                    <span v-if="!$v.formData.amount_overDue.numeric" class="text-danger">{{ $tc('validation.numbers_only') }}</span>
                    <span v-if="!$v.formData.amount_overDue.maxLength" class="text-danger">{{ $t('validation.price_maxlength') }}</span>
                    <span v-if="!$v.formData.amount_overDue.minValue" class="text-danger">{{ $t('validation.price_minvalue') }}</span>
                </div>
            </div>
        </div>
        
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeFinancialModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          color="theme"
          icon="save"
          type="submit"
        >
         {{ !isEdit ? $t('general.save') : $t('general.update') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength, maxLength, email, url, numeric,minValue,maxValue } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
        isLoading: false,
        isEdit: false,
        facilityNatureOptions: ['Funded','Non Funded'],
        facilityOriginOptions:['Existing','New','Enhancement'],
        facilityTypeOptions:['Personal','Business'],
        formData: {
            id:null,
            s_no: null,
            facility_origin:null,
            facility_nature:null,
            facility_type:null,
            amount:null,
            amount_overDue:null,
            tenor:null,
            collaterals:null,
            bank_name:null,
        },
    }    
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
    ...mapGetters('currency', [
      'defaultCurrencyForInput'
    ]),
    amount: {
      get: function () {
        return this.formData.amount / 100
      },
      set: function (newValue) {
        this.formData.amount = newValue * 100
      }
    },
    amount_overDue: {
      get: function () {
        return this.formData.amount_overDue / 100
      },
      set: function (newValue) {
        this.formData.amount_overDue = newValue * 100
      }
    },
  },
  created(){
  },
 validations: {
      formData: {
        s_no: {
            required,
            minLength: minLength(3)
        },
        facility_nature:{
            required
        },
        facility_origin:{
          required
        },
        facility_type:{
            required
        },
        bank_name:{
            required
        },
        amount:{
            required,
            numeric,
            maxLength: maxLength(20)
        },
        amount_overDue:{
            numeric,
            maxLength: maxLength(20)
        },
        tenor:{
            required
        },
        collaterals:{
            required
        }
        
      },
 },
  async mounted () {
    this.$refs.s_no.focus = true
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
      ...mapActions('financialFacility', [
      'addFinancialFacility',
      'updateFinancialFacility'
    ]),
    resetFormData () {
        
        this.formData = {
            id:null,
            s_no: null,
            facility_origin:null,
            facility_nature:null,
            facility_type:null,
            amount:null,
            amount_overDue:null,
            tenor:null,
            collaterals:null,
            bank_name:null,
        }
        this.$v.formData.$reset()
    },
    async submitFinancialData () {
        this.$v.formData.$touch()
        if (this.$v.$invalid) {
            return true
        }
        let  response;
        if (this.isEdit) {
            response = await this.updateFinancialFacility(this.formData)
            if (response.data.result=='true') { 
            window.toastr['success'](this.$t('profile.financial_facilities.updated_message'))
            this.closeFinancialModal()
            return true
            }
            window.toastr['error'](response.data.error)
        } else {
            response = await this.addFinancialFacility(this.formData)  
            if (response.data.result=='true') { 
                this.isLoading = false
                window.toastr['success'](this.$tc('profile.financial_facilities.created_message'))
                this.closeFinancialModal()
                return true
            } 
            window.toastr['error'](response.data.errors)
        }   
    },
     async setData () {
      this.formData = {
        id: this.modalData.id,
        s_no: this.modalData.s_no,
        facility_origin:this.modalData.facility_origin,
        facility_nature: this.modalData.facility_nature,
        facility_type:this.modalData.facility_type,
        amount:this.modalData.amount,
        amount_overDue:this.modalData.amount_overDue,
        tenor:this.modalData.tenor,
        collaterals:this.modalData.collaterals,
        bank_name:this.modalData.bank_name,
      }
    },
    closeFinancialModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    },
  }
}
</script>
